import ResourceComponent from '../../../common/ResourceComponent';
import {percentage} from '../../../common/TableFormatters';
import defaultImage from './no_image.png';
import {Carousel} from 'react-responsive-carousel';
import React from 'react';
import {getMaterialImageAlt} from '../../../common/Utils';

class EmbItemCarousel extends ResourceComponent {

    render() {
        const {settings, big_pictures, item, card_detail, setImgSrc, openGallery} = this.props;

        const discountBannerStyle = {
            backgroundColor: settings.banner_color ? settings.banner_color : 'transparent',
            color: settings.font_color ? settings.font_color : 'white',
            position: 'absolute',
            top: '0px',
        };

        const isVideo = (pic) => {
            return pic.content_type && pic.content_type.includes('video') ? 'show-video-icon' : 'hide-video-icon';
        };

        return (
            <Carousel
                infiniteLoop autoPlay={settings.rotate_images}
                interval={5000}
                swipeable emulateTouch stopOnHover useKeyboardArrows
                selectedItem={item.pictures && item.pictures.findIndex(pic => item.picture_id === pic.id)}
                onClickItem={(index) => {
                    if (big_pictures && big_pictures.length > 0) {
                        openGallery(item.pictures.find((item, itemIndex) => itemIndex === index));
                    }
                }}
            >
                {(item.pictures && item.pictures.length > 0)
                    ? item.pictures.map((pic, index) =>
                        <div key={index} className={`center ${isVideo(pic)}`}>
                            {card_detail.sale_discount && item.discount && item.price !== item.price_no_discount &&
                                <div className='discount-banner' style={discountBannerStyle}>
                                    <span className='sale-card'>SALE!</span>
                                    <span className='discount-card'>
                                    {percentage(item.price, item.price_no_discount)}
                                </span>
                                </div>
                            }
                            <img
                                className={`${isVideo(pic)}`}
                                key={index}
                                style={{display: card_detail.images ? 'inherit' : 'none'}}
                                src={pic.content_type && setImgSrc(card_detail, pic)}
                                alt={getMaterialImageAlt(item, pic)}
                            />
                        </div>)
                    : <div>
                        {card_detail.sale_discount && item.discount && item.price !== item.base_price &&
                            <div className='discount-banner' style={discountBannerStyle}>
                                <span className='sale-card'>SALE!</span>
                                <span className='discount-card'>
                                {percentage(item.price, item.price_no_discount)}
                            </span>
                            </div>
                        }
                        <img
                            className={'hide-video-icon'}
                            key={Math.random()}
                            src={defaultImage}
                            alt='Image placeholder for missing image'
                        />
                    </div>
                }
            </Carousel>
        );
    }
}

export default EmbItemCarousel;



// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/EmbItemCarousel.js